export enum ModalTypes {
    login = "login",
    contact = "contact",
    signOut = "signOut",
    sizeGuide = "sizeGuide",
    globalSizeGuide = "globalSizeGuide",
    forgotPassword = "forgotPassword",
    createAccount = "createAccount",
    thankYouForSignUp = "thankYouForSignUp",
    contactForm = "contactForm",
    contactFormSubmitted = "contactFormSubmitted",
    shippingDetails = "shippingDetails",
    liveChat = "liveChat",
    chatIsNotAvailable = "chatIsNotAvailable",
    chat = "chat",
    giftWrapping = "giftWrapping",
    addToWishList = "addToWishlist",
    base = "base",
    upgradeAccount = "upgradeAccount",
    eccoPass = "eccoPass",
    eccoClubBalanceHistory = "eccoClubBalanceHistory",
    tierLevelInfo = "tierLevelInfo",
    accountDeactivation = "accountDeactivation",
    legal = "legal",
    returnLabel = "returnLabel",
    newsletterSignup = "newsletterSignup",
}
